import React from "react";

import Slider from "react-slick";

const Testimonials = ({ classicHeader, darkTheme }) => {
  const reviews = [
    {
      name: "Vincent Schröder",
      position: "Engineering Manager / Product Engineer",
      src: "images/testimonial/vincent-profile.jpeg",
      desc: "I had the pleasure of giving Alkin his first opportunity in the tech industry, and I'm really glad I did. He joined us at VEHICULUM as a junior frontend engineer, one of the first engineers to come on board after the company's transition, and it was clear from the start that he had something special. Alkin came from a completely different background, but he took the initiative to complete a coding bootcamp and mastered our coding challenge (before AI era!) What impressed me most was how quickly he picked things up and his motivation. He is a fast learner, curious, and passionate about frontend and fullstack engineering. On top of that, he's just a really kind person who was always grateful for the chance. I'm proud to have been part of the start of his tech journey and I'm excited to see where he goes next. Keep up the great energy, Alkin you're just getting started.",
      rating: 5,
    },
    {
      name: "Antonio Saleme",
      position:
        "Full Stack Developer | JavaScript · TypeScript · Next.js · React · Terraform | AWS Cloud Engineer",
      src: "images/testimonial/antonio-profile.jpeg",
      desc: "Working with Alkin at Vehiculum was a truly enriching experience. From the very beginning, he stood out as an incredibly generous and collaborative person. We both started as junior developers, and I had the chance to witness his rapid growth in knowledge and technical understanding. Alkin is someone I'd always want on my team — responsible, reliable, and a great team player. But what really shows is his genuine love for what he does.",
      rating: 5,
    },
  ];

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
    ],
  };
  return (
    <section
      id="testimonial"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Testimonial
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Recommendations
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}

        <Slider {...settings}>
          {reviews.length > 0 &&
            reviews.map((value, index) => (
              <div className="item" key={index}>
                <div className={"border rounded p-5 bg-white"}>
                  <div className="d-flex align-items-center mt-auto mb-4">
                    <img
                      className="img-fluid rounded-circle border d-inline-block"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                      }}
                      src={value.src}
                      alt={value.name}
                    />
                    <p className="ms-3 mb-0">
                      <strong
                        className={
                          "d-block fw-600 " +
                          (darkTheme ? "text-white" : "text-dark")
                        }
                      >
                        {value.name}
                      </strong>
                      <span className="text-muted fw-500">
                        {" "}
                        {value.position}{" "}
                      </span>
                    </p>
                  </div>
                  <p
                    className={
                      " fw-500 mb-4 " + (darkTheme ? "text-white" : "text-dark")
                    }
                  >
                    "{value.desc}"
                  </p>
                  {/* <span className="text-2">
                    {[...Array(value.rating)].map((value, i) => (
                      <i className="fas fa-star text-warning" key={i} />
                    ))}
                  </span> */}
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
